var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80005 4.5C1.80005 3.50588 2.60594 2.7 3.60005 2.7H10.8C11.7942 2.7 12.6 3.50588 12.6 4.5V13.5C12.6 14.4941 13.4059 15.3 14.4 15.3H3.60005C2.60594 15.3 1.80005 14.4941 1.80005 13.5V4.5ZM4.50005 5.4H9.90005V9H4.50005V5.4ZM9.90005 10.8H4.50005V12.6H9.90005V10.8Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.3H14.4C15.3942 6.3 16.2 7.10588 16.2 8.1V13.05C16.2 13.7956 15.5956 14.4 14.85 14.4C14.1045 14.4 13.5 13.7956 13.5 13.05V6.3Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.3cb0b3b5573eb9ab3b71fb6b3a8a0e1c.svg";
export { ForwardRef as ReactComponent };